import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "c-nav",
  role: "navigation",
  "aria-label": "sub navigation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "マイページ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "会員情報", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "パスワード変更", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "メールアドレス変更", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "認証用電話番号登録", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "メール受信許可", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "ログアウト", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "退会する", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "c-navitem c-navitem—-top",
      "active-class": "is-active",
      to: { name: 'MypageTop' },
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change-isActive', false)))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "c-navitem c-navitem—-profile",
      "active-class": "is-active",
      to: { name: 'Profile' },
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-isActive', false)))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "c-navitem c-navitem—-password",
      "active-class": "is-active",
      to: { name: 'ChangePassword' },
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change-isActive', false)))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "c-navitem c-navitem—-email",
      "active-class": "is-active",
      to: { name: 'ChangeEmail' },
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change-isActive', false)))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "c-navitem c-navitem—-auth-phone",
      "active-class": "is-active",
      to: { name: 'AuthPhone' },
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('change-isActive', false)))
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "c-navitem c-navitem—-mail-permission",
      "active-class": "is-active",
      to: { name: 'MailPermission' },
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('change-isActive', false)))
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _createElementVNode("a", {
      class: "c-navitem c-navitem—-signout",
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
    }, _hoisted_9),
    _createVNode(_component_router_link, {
      class: "c-navitem c-navitem—-delete",
      "active-class": "is-active",
      to: { name: 'Withdrawal' },
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('change-isActive', false)))
    }, {
      default: _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    })
  ]))
}